import type { FC } from 'react';
import type { ElementProps } from './Element';

import React from 'react';
import { Element } from './Element';

type ParagraphProps = Omit<
	ElementProps, 'as'
>;

export const P: FC<ParagraphProps> = ({
	dangerouslySetInnerHTML,
	textSize = 'md',
	lineHeight = 'normal',
	weight = 'normal',
	children,
	// @ts-expect-error as Omitted in the type, but one might still pass it...
	as, // Make sure as doesn't end up in otherProps.
	...otherProps
}) => (children || dangerouslySetInnerHTML) ? (
	<Element
		{...otherProps}
		as='p'
		dangerouslySetInnerHTML={children ? undefined : dangerouslySetInnerHTML}
		lineHeight={lineHeight}
		textSize={textSize}
		weight={weight}
	>
		{children ? children : undefined}
	</Element>
) : null;
